import { Content } from './styles';
import portal from '../../../assets/assets/portal.svg';
import { ImWhatsapp } from 'react-icons/im';
import { LuAtSign } from 'react-icons/lu';

interface SubMenuProps {
  text: string;
}

export function SubMenu({ text }: SubMenuProps) {
  return (
    <Content>
      {text === 'Todos' && (
        <>
          <img src={portal} alt="" />
        </>
      )}
      {text === 'Whatsapp' && (
        <div
          style={{
            marginLeft: '1rem',
            color: '#0A78CB',
          }}
        >
          <ImWhatsapp />
        </div>
      )}
      {text === 'Portal' && (
        <div
          style={{
            marginLeft: '1rem',
            color: '#0A78CB',
          }}
        >
          <LuAtSign />
        </div>
      )}

      <p>{text}</p>
    </Content>
  );
}
